(() => {
  const initSlider = () => {
    const subCollectionsListSwiper = document.querySelector(
      ".collection__subtitles"
    );

    if (subCollectionsListSwiper) {
      let swiperParams = {
        slidesPerView: 1.8,
        spaceBetween: 32,
        draggable: true,
        navigation: {
          nextEl: '.collection__products-container .scroll-slider-nav-button--next',
          prevEl: '.collection__products-container .scroll-slider-nav-button--prev',
        },
        breakpoints: {
          768: {
            slidesPerView: "auto",
            spaceBetween: 64,
          },
        },
      };

      const listSwiper = new Swiper(subCollectionsListSwiper, swiperParams);
    }
  };

  // Initial call
  document.addEventListener("DOMContentLoaded", initSlider);

  // Re-init on section load
  document.addEventListener("shopify:section:load", function (section) {
    initSlider(section.target);
  });
})();
